import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import {COLORS} from '@/utils/constants';

const transformData = [
    {
        name: 'Yes',
        color: COLORS.e4ImpactBlue
    },
    {
        name: 'No',
        color: COLORS.e4ImpactOrange
    }
];

/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: Did you manage to have your product in the market?
 * 
 * == final
 * biz_product_sold_t1
 * 
 * @param props 
 * @returns 
 */
export const existingEntrepreneursSellingOnMarketChartCalculation = (props: any) => {
    const data = transformData.map(({name, color}) => ({
        name,
        color,
        y: props.finalSubmissions.filter((submission: any) => submission.biz_product_sold_t1 === name).length
    }));
    const values = transformData.map(({name}) => name);
    
    return getDefaultPieFormatting(
        'of existing entrepreneurs that started to sell their product on the market',
        data,
        0,
        {},
    ) as Highcharts.Options;
}